export enum InformationChannel {
  KNOWN_REFERRED = "KNOWN_REFERRED",

  EMPLOYEE_PORTAL = "EMPLOYEE_PORTAL",

  SOCIAL_MEDIA = "SOCIAL_MEDIA",

  OTHERS = "OTHERS",
}
